import {
    FaCheckCircle,
    FaDownload,
    FaEnvelope,
    FaFacebookF,
    FaHome,
    FaInstagram,
    FaMountain,
    FaPhoneAlt,
    FaWhatsapp
} from "react-icons/fa";

import jsPDF from "jspdf";
import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./css/Success.css";

function Success() {
    const location = useLocation();
    
    // ✅ Mengambil data dari navigasi
    const { bookingData } = location.state || {};

    // Efek samping saat halaman dimuat (Scroll ke atas otomatis)
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // 🔥 FUNGSI OTOMATIS KIRIM WHATSAPP
    const handleWhatsApp = () => {
        const nomorAdmin = "6281216687367"; 
        const bookingID = `PW${Date.now().toString().slice(-6)}`;
        
        // Menyusun pesan yang rapi untuk dikirim ke admin
        const pesan = `Halo Permata Wisata, saya ingin konfirmasi pembayaran:
        
📌 *Kode Booking:* ${bookingID}
🏡 *Villa:* ${bookingData?.villa_name || "Villa Reservasi"}
👤 *Nama:* ${bookingData?.full_name || "-"}
📅 *Check-in:* ${bookingData?.check_in || "-"}
💰 *Total:* Rp ${bookingData?.total_price?.toLocaleString() || "0"}

Mohon segera diverifikasi ya, terima kasih!`;

        const url = `https://wa.me/${nomorAdmin}?text=${encodeURIComponent(pesan)}`;
        window.open(url, "_blank");
    };

    // 🔥 FUNCTION CONVERT IMAGE TO BASE64 (Untuk PDF)
    const getBase64FromUrl = async (url) => {
        try {
            const res = await fetch(url);
            const blob = await res.blob();
            return new Promise((resolve) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.readAsDataURL(blob);
            });
        } catch (err) {
            console.error("Gagal memuat gambar untuk PDF", err);
            return "";
        }
    };

    // 🔥 DOWNLOAD PDF PREMIUM + IMAGE
    const handleDownload = async () => {
        const doc = new jsPDF();
        
        const imageUrl = bookingData?.villa_image || "https://images.unsplash.com/photo-1505691938895-1758d7feb511";
        const base64Img = await getBase64FromUrl(imageUrl);

        // HEADER PDF
        doc.setFillColor(11, 60, 93);
        doc.rect(0, 0, 210, 30, "F");
        doc.setFontSize(18);
        doc.setTextColor(255, 255, 255);
        doc.text("PERMATA WISATA", 105, 15, null, null, "center");
        doc.setFontSize(10);
        doc.text("Booking Confirmation", 105, 22, null, null, "center");

        // IMAGE VILLA
        if (base64Img) {
            doc.addImage(base64Img, "JPEG", 15, 40, 180, 60);
        }

        // CONTENT BOX
        doc.setFillColor(245, 247, 250);
        doc.roundedRect(10, 110, 190, 160, 5, 5, "F");

        doc.setFontSize(14);
        doc.setTextColor(0, 0, 0);
        doc.text("Booking Details", 15, 125);

        // VILLA INFO
        doc.setFontSize(12);
        doc.text(bookingData?.villa_name || "Villa Reservasi", 15, 135);
        doc.setFontSize(10);
        doc.setTextColor(100);
        doc.text("Sleman, Yogyakarta", 15, 142);

        doc.setDrawColor(200);
        doc.line(15, 148, 195, 148);

        // DETAIL PEMESANAN
        doc.setTextColor(0);
        doc.text("Check-in", 15, 160);
        doc.text("Check-out", 15, 170);
        doc.text("Guests", 15, 180);

        doc.text(bookingData?.check_in || "-", 120, 160);
        doc.text(bookingData?.check_out || "-", 120, 170);
        doc.text((bookingData?.guests || "0") + " guests", 120, 180);

        doc.line(15, 200, 195, 200);

        // GUEST INFO
        doc.setFontSize(12);
        doc.text("Guest Information", 15, 215);
        doc.setFontSize(10);
        doc.text("Name", 15, 225);
        doc.text("Email", 15, 235);
        doc.text("WhatsApp", 15, 245);

        doc.text(bookingData?.full_name || "-", 120, 225);
        doc.text(bookingData?.email || "-", 120, 235);
        doc.text(bookingData?.whatsapp || "-", 120, 245);

        // TOTAL
        doc.setFontSize(12);
        doc.text("Total Payment", 15, 260);
        doc.setFontSize(16);
        doc.setTextColor(11, 60, 93);
        const price = bookingData?.total_price || 0;
        doc.text("Rp " + price.toLocaleString(), 15, 270);

        doc.save("booking-permata-wisata.pdf");
    };

    return (
        <div className="success-page">

            {/* ==========================================================
               NAVBAR (SOLID DEEP BLUE - FULL WIDTH)
               ========================================================== */}
            <nav className="navbar">
                <div className="logo">
                    <div className="logo-icon">
                        <FaMountain />
                    </div>
                    <div className="logo-text">
                        <h3>Permata Wisata</h3>
                        <span>Jogja Tourism</span>
                    </div>
                </div>

                <div className="nav-menu">
                    <Link to="/">Home</Link>
                    <Link to="/villas">Villas</Link>
                    <a
                        href="https://wa.me/081216687367?text=Halo%20admin%20Permata%20Wisata"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="contact-btn"
                    >
                        Hubungi Kami
                    </a>
                </div>
            </nav>

            {/* ==========================================================
               MAIN CONTENT WRAPPER (UNTUK MEMBATASI UKURAN KARTU)
               ========================================================== */}
            <div className="success-content-wrapper">
                <div className="success-container">
                    
                    {/* CARD 1: STATUS UTAMA */}
                    <div className="success-card">
                        <div className="icon-success">
                            <FaCheckCircle />
                        </div>
                        <h1>Booking Confirmed!</h1>
                        <p>Terima kasih! Reservasi Anda berhasil dikirim.</p>

                        <div className="booking-code">
                            <span>Booking Number</span>
                            <h2>PW{Date.now().toString().slice(-6)}</h2>
                        </div>

                        <div className="status-row">
                            <div className="status-item">
                                <FaEnvelope /> Email Sent
                            </div>
                            <div 
                                onClick={handleWhatsApp}
                                className="status-item wa"
                                style={{ cursor: "pointer" }}
                            >
                                <FaWhatsapp /> Confirm Payment
                            </div>
                        </div>
                    </div>

                    {/* CARD 2: DETAIL DATA RESERVASI */}
                    <div className="detail-card modern">
                        <h3>Booking Details</h3>
                        <div className="detail-content modern">
                            <img
                                src={bookingData?.villa_image || "https://images.unsplash.com/photo-1505691938895-1758d7feb511"}
                                alt="villa"
                            />
                            <div className="detail-info modern">
                                <h4>{bookingData?.villa_name || "Villa Name"}</h4>
                                <p className="location">Sleman, Yogyakarta</p>

                                <div className="detail-row">
                                    <span>Check-in</span>
                                    <span>{bookingData?.check_in || "-"}</span>
                                </div>
                                <div className="detail-row">
                                    <span>Check-out</span>
                                    <span>{bookingData?.check_out || "-"}</span>
                                </div>
                                <div className="detail-row">
                                    <span>Guests</span>
                                    <span>{bookingData?.guests || "0"} guests</span>
                                </div>
                            </div>
                        </div>

                        <hr />
                        <h4>Guest Information</h4>
                        <div className="detail-row">
                            <span>Name</span>
                            <span>{bookingData?.full_name || "-"}</span>
                        </div>
                        <div className="detail-row">
                            <span>Email</span>
                            <span>{bookingData?.email || "-"}</span>
                        </div>
                        <div className="detail-row">
                            <span>WhatsApp</span>
                            <span>{bookingData?.whatsapp || "-"}</span>
                        </div>

                        <hr />
                        <div className="payment-summary">
                            <div>
                                <h4>Total Payment</h4>
                                <p className="status">Pending Verification</p>
                            </div>
                            <h2>Rp {bookingData?.total_price?.toLocaleString() || "0"}</h2>
                        </div>
                    </div>

                    {/* CARD 3: LANGKAH SELANJUTNYA */}
                    <div className="next-card">
                        <h3>What's Next?</h3>
                        <ul>
                            <li>Kami akan verifikasi pembayaran dalam 1–2 jam</li>
                            <li>Anda akan menerima email konfirmasi</li>
                            <li>Tunjukkan voucher saat check-in</li>
                            <li>Hubungi kami via WhatsApp jika ada pertanyaan</li>
                        </ul>
                    </div>

                    {/* TOMBOL AKSI */}
                    <div className="action-buttons">
                        <button onClick={handleDownload} className="download-btn">
                            <FaDownload /> Download PDF
                        </button>
                        <Link to="/">
                            <button className="home-btn">
                                <FaHome /> Back to Home
                            </button>
                        </Link>
                    </div>

                    {/* LAYANAN BANTUAN */}
                    <div className="help-section">
                        <p>Need Help?</p>
                        <div className="help-contact">
                            <div onClick={handleWhatsApp} style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: "5px" }}>
                                <FaWhatsapp /> 081216687367
                            </div>
                            <span>|</span>
                            <a href="mailto:permatawisata@gmail.com">
                                <FaEnvelope /> permatawisata@gmail.com
                            </a>
                        </div>
                    </div>
                    
                </div>
            </div>

            {/* ==========================================================
               FOOTER (SOLID DEEP BLUE - FULL WIDTH)
               ========================================================== */}
            <footer className="footer-container">
                <div className="footer-content">
                    <div className="footer-section footer-left">
                        <h2>Permata Wisata</h2>
                        <span>Jogja Tourism</span>
                        <p>
                            Your trusted partner for villa and homestay bookings in Jogja.
                        </p>
                    </div>

                    <div className="footer-section footer-center">
                        <h3>Contact Us</h3>
                        <p>
                            <FaEnvelope className="footer-icon" /> 
                            <span>info@permatawisata.com</span>
                        </p>
                        <p>
                            <FaPhoneAlt className="footer-icon" /> 
                            <span>+62 812-3456-7890</span>
                        </p>
                    </div>

                    <div className="footer-section footer-right">
                        <h3>Follow Us</h3>
                        <div className="social-icons">
                            <a href="https://instagram.com" target="_blank" rel="noreferrer" className="social-icon">
                                <FaInstagram />
                            </a>
                            <a href="https://facebook.com" target="_blank" rel="noreferrer" className="social-icon">
                                <FaFacebookF />
                            </a>
                        </div>
                    </div>
                </div>
                
                <hr className="footer-divider" />
                <p className="footer-bottom">© 2026 Permata Wisata. All rights reserved.</p>
            </footer>
        </div>
    );
}

export default Success;